import MetaTags from "@/components/seo/meta-tags";
import CompliancesAndCertifications from "@/components/us-website/CompliancesAndCertifications/CompliancesAndCertifications";
import ContactUsForm from "@/components/us-website/ContactUsForm/ContactUsForm";
import CustomManufacturingSolutions from "@/components/us-website/CustomManufacturingSolutions/CustomManufacturingSolutions";
import FactoriesAndLabs from "@/components/us-website/FactoriesAndLabs/FactoriesAndLabs";
import FeatureImageWithBlur from "@/components/us-website/FeatureImageWithBlur/FeatureImageWithBlur";
import LocationWrapper from "@/components/us-website/LocationWrapper";
import OurManufacturingNetwork from "@/components/us-website/OurManufacturingNetwork/OurManufacturingNetwork";
import OurServices from "@/components/us-website/OurServices/OurServices";
import ReactionCapabilitiesTestingEquipments from "@/components/us-website/ReactionCapabilitiesTestingEquipments/ReactionCapabilitiesTestingEquipments";
import SustainabilityCustomManufacturing from "@/components/us-website/SustainabilityCustomManufacturing/SustainabilityCustomManufacturing";
import { getCDNImageUrl } from "@/utils/Common";
import ContactUsModalBtn from "@/components/Modal/ContactUs";
import React, { useRef } from "react";

function CustomManufacturing() {
  const servicesRef = useRef(null);

  const scrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <LocationWrapper>
      <MetaTags
        title="Elchemy offers end-to-end custom manufacturing solutions"
        description="Elchemy provides turnkey custom chemical manufacturing solutions—from formulation to delivery—tailored for personal care, fragrance, and more."
        includeAlternateLink={true}
      />
      <div className="overflow-hidden">
        {/* Feature Image With Blur Show Buttons */}
        <FeatureImageWithBlur
          heading="Welcome to Elchemy's World of
Custom Manufacturing Excellence"
          description="Seamless end‑to‑end solutions in formulation, manufacturing, quality, and compliance."
          imageSrc={getCDNImageUrl("custom-manufacturing.webp")}
          showPrimaryButton={true}
          primaryButtonComponent={
            <ContactUsModalBtn
              isUsVersion={true}
              heading="Request Custom Formulation"
              service="2"
              subHeading="Fill in the details required to get the sample."
              classes="w-full sm:w-[240px] h-[44px] sm:h-[48px] bg-[#EF4136] font-mukta text-[14px] sm:text-[16px] text-[#fff] rounded-[8px]"
            >
              <div>Request Custom Formulation</div>
            </ContactUsModalBtn>
          }
          showSecondaryButton={true}
          secondaryButtonText="Explore Our Services"
          onClickSecondaryButton={scrollToServices}
        />
        {/* Our Services */}
        <div ref={servicesRef}>
          <OurServices />
        </div>
        {/* Our Manufacturing Network */}
        <OurManufacturingNetwork />
        {/* Tabs - Reaction Capabilities,Testing Equipments */}
        <ReactionCapabilitiesTestingEquipments />
        {/* Custom Manufacturing Solutions */}
        <CustomManufacturingSolutions />
        {/* Compliances and Certifications */}
        <CompliancesAndCertifications />
        {/* Sustainability */}
        <SustainabilityCustomManufacturing />
        {/* Factories and R&D Labs */}
        {/* <FactoriesAndLabs /> */}
        {/* Contact Us Form */}
        <ContactUsForm />
      </div>
    </LocationWrapper>
  );
}

export default CustomManufacturing;
